import { Button, useMediaQuery } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isUndefined } from 'lodash'
import { useEffect } from 'react'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import MarkdownEditor from '../../pages/InternalPage/RequestMessagesPage/components/MarkdownEditor'
import { useProfileStore } from '../../store/storeProfile'
import { useRequestsStore } from '../../store/storeRequests'
import { useWrapperStore } from '../../store/storeWrapper'
import { theme } from '../../theme'
import Light from './../../assets/icons/Light.svg?react'
import PenSquare from './../../assets/icons/PenSquare.svg?react'

export const AssistantInfoDialog = ({
    open,
    handleClose,
    handleSubmit,
    assistant,
    handleNewReply,
    availableNameTariff,
    isBuy,
}) => {
    const { requestDetail } = useRequestsStore((state) => state)

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { userTariff } = useProfileStore()
    const { checkIsFreeAssistant, freeAssistant, buyAssistantSubscription, isTempUser } =
        useWrapperStore((state) => state)

    useEffect(() => {
        checkIsFreeAssistant(assistant.id)
    }, [])

    const handleClickNewReply = () => {
        handleClose()
        handleNewReply()
    }

    // const handleClickBuySubmit = async () => {
    //     buyAssistantSubscription(assistant.id)
    //     await handleClose()
    //     await handleNewReply()
    // }
    return (
        <ModalDialogWrapper
            sx={{
                '.MuiPaper-root': {
                    width: '800px',
                    maxWidth: '800px',
                    height: 'auto',
                },
            }}
            footerActions={
                <>
                    {assistant.available === 'FREE' && (
                        <Button
                            onClick={handleClickNewReply}
                            disabled={availableNameTariff}
                            variant="contained"
                            startIcon={<PenSquare />}>
                            {!availableNameTariff
                                ? requestDetail
                                    ? 'Выбрать'
                                    : 'Новый запрос'
                                : `Доступен на уровне «${availableNameTariff}»`}
                        </Button>
                    )}

                    {isBuy && (
                        <Button
                            disabled={isTempUser || userTariff?.tariff.tariff_type === 'FREE'}
                            onClick={handleClickNewReply}
                            variant="contained"
                            startIcon={<PenSquare />}>
                            {requestDetail ? 'Выбрать' : 'Новый запрос'}
                        </Button>
                    )}

                    {!isBuy && assistant.available !== 'FREE' && (
                        <Stack
                            direction={isMobile ? 'column' : 'row'}
                            spacing={1}
                            sx={{ width: '100%' }}>
                            <Button variant="outlined" fullWidth onClick={handleClose}>
                                Отменить
                            </Button>

                            {!isUndefined(freeAssistant) && (
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                    fullWidth
                                    disabled={
                                        isTempUser || userTariff?.tariff.tariff_type === 'FREE'
                                    }>
                                    {freeAssistant
                                        ? 'Попробовать бесплатно 1 месяц*'
                                        : `Подключить за ${assistant?.price} коинов в месяц`}
                                </Button>
                            )}
                        </Stack>
                    )}
                </>
            }
            descriptionFooterActions={
                freeAssistant && assistant.available !== 'FREE' && !isBuy ? (
                    <Typography variant="body2">
                        *С 2-го месяца ежемесячная оплата {assistant?.price} коинов, отключить
                        подписку можно в любой момент
                    </Typography>
                ) : (
                    ''
                )
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={`Ассистент "${assistant.name}"`}>
            <MarkdownEditor text={assistant?.full_description.replaceAll('---\n', '')} />
            <Stack
                sx={{
                    borderRadius: '12px',
                    background: ' #F6F6F6',
                    display: 'flex',
                    padding: '16px',
                    justifyContent: 'center',
                    gap: '10px',
                    alignSelf: 'stretch',
                }}>
                <MarkdownEditor text={assistant?.example.replaceAll('---\n', '')} />
            </Stack>
            <Stack direction="row" spacing={0.5} mt={2} sx={{ alignItems: 'center' }}>
                <Light />
                <Typography sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '20px', mb: 3 }}>
                    {assistant?.based_on}
                </Typography>
            </Stack>

            <Typography
                mt={3}
                sx={{
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    color: '#5A5C5E',
                    fontStyle: 'italic',
                }}>
                {assistant?.disclamer}
            </Typography>
        </ModalDialogWrapper>
    )
}
